import m from "../../geodata/es2015/cyprusHigh";
window.am4geodata_cyprusHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/cyprusHigh.js
// module id = null
// module chunks = 